export default __webpack_public_path__ + "static/media/pos-logo-bordered.ce42ab2e.png";